export const localization_fa = {
    
    actions: 'عملیات',
    and: 'و',
    cancel: 'انصراف',
    changeFilterMode: 'تغییر حالت فیلتر',
    changeSearchMode: 'تغییر حالت جستجو',
    clearFilter: 'پاک کردن فیلتر',
    clearSearch: 'پاک کردن جستجو',
    clearSelection: 'پاک کردن انتخاب',
    clearSort: 'پاک کردن مرتب سازی',
    clickToCopy: 'کپی کردن',
    copy: 'کپی',
    collapse: 'بستن',
    collapseAll: 'بستن همه',
    columnActions: 'اقدامات ستون',
    copiedToClipboard: 'کپی به کلیپ بورد',
    dropToGroupBy: 'حذف گروه بندی {column}',
    edit: 'ویرایش',
    expand: 'باز کردن',
    expandAll: 'باز کردن همه',
    filterArrIncludes: 'شامل',
    filterArrIncludesAll: 'شامل همه',
    filterArrIncludesSome: 'شامل برخی',
    filterBetween: 'بین',
    filterBetweenInclusive: 'شامل بین',
    filterByColumn: 'فیلتر توسط {column}',
    filterContains: 'شامل',
    filterEmpty: 'خالی',
    filterEndsWith: 'به پایان می رسد با',
    filterEquals: 'مساوی',
    filterEqualsString: 'مساوی',
    filterFuzzy: 'درهم',
    filterGreaterThan: 'بزرگتر از',
    filterGreaterThanOrEqualTo: 'بزرگتر مساوی با',
    filterInNumberRange: 'بین',
    filterIncludesString: 'شامل',
    filterIncludesStringSensitive: 'شامل',
    filterLessThan: 'کمتر از',
    filterLessThanOrEqualTo: 'کمتر مساوی با',
    filterMode: ' فیلتر :{filterType}',
    filterNotEmpty: 'خالی نبودن  ',
    filterNotEquals: 'مساوی نبودن با  ',
    filterStartsWith: 'شروع با ',
    filterWeakEquals: 'مساوی با ',
    filteringByColumn: 'فیلتر با {column} - {filtertype} {filtervalue}',
    goToFirstPage: 'صفحه اول',
    goToLastPage: 'صفحه آخر',
    goToNextPage: 'صفحه بعد',
    goToPreviousPage: 'صفحه قبل',
    grab: 'گرفتن',
    groupByColumn: 'گروه بندی توسط {column}',
    groupedBy: 'گروه بندی توسط ',
    hideAll: 'پنهان کردن همه',
    hideColumn: 'پنهان کردن ستون {column}',
    max: 'حداکثر',
    min: 'حداقل',
    move: 'حرکت',
    noRecordsToDisplay: '',
  //   'موردی برای نمایش نمی باشد.',
    noResultsFound: 'موردی یافت نشد.',
    of: 'از',
    or: 'یا',
    pin: 'پین',
    pinToLeft: 'پین به چپ',
    pinToRight: 'پین به راست',
    resetColumnSize: 'تنظیم مجدد اندازه ستون',
    resetOrder: 'بازنشانی سفارش',
    rowActions: 'اقدامات ردیف',
    rowNumber: '#',
    rowNumbers: 'اعداد ردیف',
    rowsPerPage: 'تعداد ردیف در هر صفحه',
    save: 'ذخیره کردن',
    search: 'جستجو',
    selectedCountOfRowCountRowsSelected:
      '{selectedCount} از {rowCount} انتخاب شد',
    select: 'انتخاب',
    showAll: 'نمایش همه',
    showAllColumns: 'نمایش تمام ستون ها',
    showHideColumns: 'نمایش/مخفی کردن ستون ها',
    showHideFilters: 'نمایش/مخفی کردن فیلتر ها',
    showHideSearch: 'نمایش/مخفی کردن جستجو ها',
    sortByColumnAsc: 'مرتب کردن {column} صعودی ',
    sortByColumnDesc: 'مرتب کردن نزولی  {column} ',
    sortedByColumnAsc: 'مرتب شده {column} براساس صعودی ',
    sortedByColumnDesc: 'مرتب شده  {column} براساس نزولی ',
    thenBy: 'سپس توسط ',
    toggleDensity: 'حجم ردیف ها',
    toggleFullScreen: 'بزرگنمایی',
    toggleSelectAll: 'انتخاب همه',
    toggleSelectRow: 'انتخاب ردیف',
    toggleVisibility: 'نمایش',
    ungroupByColumn: 'لغو گروه بندی توسط {column}',
    unpin: 'پین کردن',
    unpinAll: 'از پین در آوردن ',
  }